(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-stove-output-calculator"] && !window.DesignMode) return;
  try {
    
(function () {
    var getSelectedUnits = function() {
        return document.getElementById('calc-units').value;
    };

    var showResult = function(output) {
        var outputElementContainer = document.getElementById('calc-result-container');
        var outputElement = document.getElementById('calc-result');
        var outputFormatted = output.toLocaleString({}, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        });

        document.querySelectorAll('.calc-recommended').forEach((item)=>{item.style.display = 'none'});
        document.querySelectorAll('.calc-alternative').forEach((item)=>{item.style.display = 'block'});

        if (output <= 4) {
          console.log(document.querySelector('[data-upper="4"]'));
          document.querySelector('[data-upper="4"]').querySelector('.calc-recommended').style.display = 'grid';
          document.querySelector('[data-upper="4"]').querySelector('.calc-alternative').style.display = 'none';
        } 
        else if (output > 4 && output <= 6) {
          document.querySelector('[data-upper="6"]').querySelector('.calc-recommended').style.display = 'grid';
          document.querySelector('[data-upper="6"]').querySelector('.calc-alternative').style.display = 'none';
        }
        else if (output > 6 && output <= 9) {
          document.querySelector('[data-upper="9"]').querySelector('.calc-recommended').style.display = 'grid';
          document.querySelector('[data-upper="9"]').querySelector('.calc-alternative').style.display = 'none';
        }
        else if (output > 9 && output <= 12) {
          document.querySelector('[data-upper="12"]').querySelector('.calc-recommended').style.display = 'grid';
          document.querySelector('[data-upper="12"]').querySelector('.calc-alternative').style.display = 'none';
        }
        else if (output > 12) {
          document.querySelector('[data-lower="12"]').querySelector('.calc-recommended').style.display = 'grid';
          document.querySelector('[data-lower="12"]').querySelector('.calc-alternative').style.display = 'none';
        }

        document.getElementById('calc-result-holding').style.display = 'none';
        outputElement.innerText = `Your ideal stove size is ${outputFormatted} kW`;
        outputElementContainer.style.display = 'block';
    };

    var calculateOutput = function(lengthMetres, widthMetres, heightMetres) {
        return lengthMetres * widthMetres * heightMetres / 14;
    };

    var configure = function() {
        var fieldsetFeet = document.getElementById('dimensions-feet');
        var fieldsetMetres = document.getElementById('dimensions-metres');

        if (getSelectedUnits() == 'm') {
            fieldsetMetres.style.display = 'grid';
            fieldsetMetres.disabled = false;
            fieldsetFeet.style.display = 'none';
            fieldsetFeet.disabled = true;
        } else {
            fieldsetMetres.style.display = 'none';
            fieldsetMetres.disabled = true;
            fieldsetFeet.style.display = 'grid';
            fieldsetFeet.disabled = false;
        }
    };

    var calculate = function(e) {
        e.preventDefault();
        if (getSelectedUnits() == 'm') {
            var lengthMetres = parseFloat(document.getElementById('calc-length-metres').value);
            var widthMetres = parseFloat(document.getElementById('calc-width-metres').value);
            var heightMetres = parseFloat(document.getElementById('calc-height-metres').value);
        } else {
            var lengthFeet = parseFloat(document.getElementById('calc-length-feet').value);
            var lengthInches = parseFloat(document.getElementById('calc-length-inches').value);
            var widthFeet = parseFloat(document.getElementById('calc-width-feet').value);
            var widthInches = parseFloat(document.getElementById('calc-width-inches').value);
            var heightFeet = parseFloat(document.getElementById('calc-height-feet').value);
            var heightInches = parseFloat(document.getElementById('calc-height-inches').value);

            var lengthMetres = (lengthInches + (12 * lengthFeet)) / 39.37;
            var widthMetres = (widthInches + (12 * widthFeet)) / 39.37;
            var heightMetres = (heightInches + (12 * heightFeet)) / 39.37;
        }

        showResult(calculateOutput(lengthMetres, widthMetres, heightMetres));
    };

    document.getElementById('calc-units').addEventListener('change', configure, false);
    document.getElementById('stove-calculator-submit').addEventListener('click', calculate, false);

    configure();
})();

  } catch(e) { console.error(e); }
})();
})();
